const title = document.querySelector('script[data-google-ratings-title]')?.dataset.googleRatingsTitle;

if (title) {
  const labelWidget = () => {
    const iframe = document.getElementById('merchantwidgetiframe');
    if (!(iframe instanceof HTMLIFrameElement)) return false;
    iframe.title = title;
    return true;
  };

  if (!labelWidget()) {
    const observer = new MutationObserver(() => {
      if (labelWidget()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
}
